/**
 * `enabled` stays false until FeatureFlagProvider applies Flagsmith `debug_logs`.
 * `log` calls before that (App boot, metadata, module init) are silent even when the flag is on.
 */
class Debugger {
    private enabled = false

    getState() {
        return this.enabled
    }

    setState(enabled: boolean) {
        this.enabled = enabled
    }

    log(...args: unknown[]) {
        if (this.enabled) {
            console.debug(...args)
        }
    }
}

export const debug = new Debugger()
